import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BillLineItem } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useEntitiesById } from "@hooks/useEntities";

export const EntityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, BillLineItem, any>) => {
        const entitiesById = useEntitiesById();
        const entityId = row.original.bill?.entityId;
        const entity =
            entityId !== undefined ? entitiesById.get(entityId) : undefined;

        return (
            <ViewTableCell>
                {entity && <EntityAvatar size="xs" entity={entity} />}
            </ViewTableCell>
        );
    },
);
